import { createAction, props } from "@ngrx/store";

export const changePassword = createAction(
  "[Settings] change password",
  props<{
    oldPassword: string;
    newPassword: string;
  }>(),
);

export const changedPassword = createAction("[Settings] changed password");

export const changePasswordFailed = createAction(
  "[Settings] change password failed",
  props<{ error: any }>(),
);

export const resetPassword = createAction(
  "[Settings] reset password",
  props<{
    key: string;
    newPassword: string;
  }>(),
);

export const resetPasswordSuccessfully = createAction(
  "[Settings] reset password successfully",
);
export const resetPasswordFailed = createAction(
  "[Settings] reset password failed",
  props<{ error?: any }>(),
);

export const changeLanguage = createAction(
  "[Settings] change language",
  props<{
    language: string;
  }>(),
);

export const changedLanguage = createAction(
  "[Settings] changed language",
  props<{ language: string }>(),
);

export const changeLanguageFailed = createAction(
  "[Settings] change language failed",
  props<{ error: any }>(),
);
